import { UserOutlined } from '@ant-design/icons';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { userSelector } from '~/App/store/auth';

const UserInfo = () => {
  const user = useRecoilValue(userSelector);
  return (
    <div
      className="flex items-center gap-2 p-4"
      style={{ borderBottom: '1px solid #eee', borderRight: '1px solid #eee' }}
    >
      <UserOutlined style={{ fontSize: 24 }} />
      <div>
        <p>{user?.name}</p>
        <p className="text-xs text-neutral-400">Username: {user?.username}</p>
      </div>
    </div>
  );
};

export default UserInfo;
